<template>
  <div class="col" :class="colClass" :style="colStyle">
      <slot></slot>
  </div>
</template>

<script>
let validator = function(obj){
    let flag = true
    let keys = Object.keys(obj)
    let judgeArr = ['span','offset']
    keys.forEach(key => {
        judgeArr.includes(key)?'':flag = false
    })
    return flag
}
export default {
    name: 'g-col',
    props: {
        span: {
            type: [Number, String]
        },
        offset: {
            type: [Number, String]
        },
        phone: {
            type: Object,
            validator
        },
        ipad: {
            type: Object,
            validator
        },
        narrowPc: {
            type: Object,
            validator
        },
        pc: {
            type: Object,
            validator
        },
        widePc: {
            type: Object,
            validator
        }
    },
    data() {
        return {
            gutter: 0
        }
    },
    methods: {
        createClasses(obj,type = '') {
            let arr = []
            if(!obj){return []}
            if(obj.span){arr.push(`col-${type}${obj.span}`)}
            if(obj.offset){arr.push(`offset-${type}${obj.offset}`)}
            return arr
        }
    },
    computed: {
        colStyle(){
            return {
                paddingLeft: this.gutter / 2 + 'px',
                paddingRight: this.gutter / 2 + 'px'
            }
        },
        colClass() {
            const {span, offset, phone, ipad, narrowPc, pc, widePc, createClasses } = this
            let x = () => {
                
            }
            return [
                span && `col-${span}`,offset && `offset-${offset}`,
                // ...[phone ? `col-phone-${phone.span} offset-phone-${phone.offset}`:''],
                ...createClasses({span,offset},''),
                ...createClasses(phone,'phone-'),
                ...createClasses(ipad,'ipad-'),
                ...createClasses(narrowPc,'narrowPc-'),
                ...createClasses(pc,'pc-'),
                ...createClasses(widePc,'widePc-')
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.col{
    $class-prefix:col-;
    @for $n from 1 through 24 {
        &.#{$class-prefix}#{$n} {
            width: ($n / 24) * 100%;
        }
    }
    $class-prefix:offset-;
    @for $n from 1 through 24 {
        &.#{$class-prefix}#{$n} {
            margin-left: ($n / 24) * 100%;
        }
    }
    @media (max-width: 576px) {
        $class-prefix:col-phone-;
        @for $n from 1 through 24 {
            &.#{$class-prefix}#{$n} {
                width: ($n / 24) * 100%;
            }
        }
        $class-prefix:offset-phone-;
        @for $n from 0 through 24 {
            &.#{$class-prefix}#{$n} {
                margin-left: ($n / 24) * 100%;
            }
        }
    }
    @media ( min-width: 577px){
        $class-prefix:col-ipad-;
        @for $n from 1 through 24 {
            &.#{$class-prefix}#{$n} {
                width: ($n / 24) * 100%;
            }
        }
        $class-prefix:offset-ipad-;
        @for $n from 0 through 24 {
            &.#{$class-prefix}#{$n} {
                margin-left: ($n / 24) * 100%;
            }
        }
    }
    @media ( min-width: 769px){
        $class-prefix:col-narrowPc-;
        @for $n from 1 through 24 {
            &.#{$class-prefix}#{$n} {
                width: ($n / 24) * 100%;
            }
        }
        $class-prefix:offset-narrowPc-;
        @for $n from 0 through 24 {
            &.#{$class-prefix}#{$n} {
                margin-left: ($n / 24) * 100%;
            }
        }
    }
    @media ( min-width: 993px){
        $class-prefix:col-pc-;
        @for $n from 1 through 24 {
            &.#{$class-prefix}#{$n} {
                width: ($n / 24) * 100%;
            }
        }
        $class-prefix:offset-pc-;
        @for $n from 0 through 24 {
            &.#{$class-prefix}#{$n} {
                margin-left: ($n / 24) * 100%;
            }
        }
    }
    @media ( min-width: 1201px) {
        $class-prefix:col-widePc-;
        @for $n from 1 through 24 {
            &.#{$class-prefix}#{$n} {
                width: ($n / 24) * 100%;
            }
        }
        $class-prefix:offset-widePc-;
        @for $n from 0 through 24 {
            &.#{$class-prefix}#{$n} {
                margin-left: ($n / 24) * 100%;
            }
        }
    }
}
</style>